<template>
  <div id="container" class="flex_one">
    <!-- {{newSearchJson}} -->
    <!--  <div>{{}}</div> -->
    <!--   <div>{{sportslist}}</div> -->
    <!--  <div>{{SeachJson}}</div>v-loading.fullscreen="loading" -->
    <!-- {{ps}}{{pi}} -->
    <div class="list_box full_layout">
      <div class="list_left_box">
        <div class="tac">
          <el-collapse v-model="activeNames" class="seach_list_left">
            <el-collapse-item name="0" v-if="newChild.length>0">
              <template slot="title">
                <span class="collapseSpan">Category</span>
              </template>
              <div class="choose_list" :class="newSearchJson.SecondID==res._id?'active':''" v-for="(res,i) in newChild" :key="i" @click="setSecondData(res)">
                {{res.Title}}
              </div>
            </el-collapse-item>
            <el-collapse-item name="1" v-if="BoxList.length>0">
              <template slot="title">
                <span class="collapseSpan">Box</span>
              </template>
              <div class="choose_list" :class="newSearchJson.BoxID==res._id?'active':''" v-for="(res,i) in BoxList" :key="i" @click="setBoxList(res)">
                {{res.Title}}
              </div>
            </el-collapse-item>
            <el-collapse-item name="2" v-if="YearList.length>0">
              <template slot="title">
                <span class="collapseSpan">Year</span>
              </template>
              <div class="choose_list" :class="newSearchJson.YearID==res._id?'active':''" v-for="(res,i) in YearList" :key="i" @click="setYearList(res)">
                {{res.Title}}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="list_right_top">
        <div class="Manufacturer">
          <div :class="newSearchJson.FirstID==item._id?'on':''" @click="setFirstData(item._id,index)" v-for='(item,index) in SearchCategory' :key='index'>
            <img :src="item.ImgUrl">
          </div>
        </div>
        <!-- <div class="Manufacturer">
          <div :class="manu=='Daka'?'on':''" @click="Manu('Daka')">
            <img src="../../../static/images/daka.png">
          </div>
          <div :class="manu=='Panini'?'on':''" @click="Manu('Panini')">
            <img src="../../../static/images/PANINI_HOBBY.png">
          </div>
          <div :class="manu=='PaniniAsia'?'on':''" @click="Manu('PaniniAsia')">
            <img src="../../../static/images/PANINI_ASIA.png">
          </div>
          <div :class="manu=='Topps'?'on':''" @click="Manu('Topps')">
            <img src="../../../static/images/topps.png">
          </div>
          <div :class="manu=='Pokemon'?'on':''" @click="Manu('Pokemon')">
            <img src="../../../static/images/POKEMON.png">
          </div>
          <div :class="manu=='Magic'?'on':''" @click="Manu('Magic')">
            <img src="../../../static/images/MAGIC.png">
          </div>
        </div> -->
        <div class="list_right_box">
          <div class="results_box" v-if="searchKey!=null">
            <span class="results_amount">{{TotalCount}}</span>
            <span class="results">results for</span>
            <span class="results_elite">donruss elite</span>
          </div>
          <!-- border_top -->
          <div class="border_top all_item">
            <div class="flex_layout_between">
              <div class="seller_tab">
                <!-- <div class="sort_price" :class="isSort == 0 ? 'activesort' : ''" @click="GoodSort(0)">Recommended</div> -->
                <div class="sort_price sort_price1" :class="isSort == 2 ? 'activesort' : ''" @click="GoodSort(2)">
                  Price
                  <em class="up_arr" :class="isPrice ? 'up' : ''"></em>
                  <em class="up_down" :class="!isPrice && isPrice != null ? 'up' : ''"></em>
                </div>
                <el-divider direction="vertical"></el-divider>
                <div class="sort_price" :class="isSort == 3 ? 'activesort' : ''" @click="GoodSort(3)">Newly Released</div>
                <!-- <el-divider direction="vertical"></el-divider>
                <div class="sort_price sort_price1" :class="isSort == 4 ? 'activesort' : ''" @click="GoodSort(4)">
                  Sales
                  <em class="up_arr" :class="isSales ? 'up' : ''"></em>
                  <em class="up_down" :class="!isSales && isSales != null ? 'up' : ''"></em>
                </div> -->
                <!-- <el-divider direction="vertical"></el-divider>
                <span class="" @click="GoodSort(3)">Newly Released</span> -->
              </div>
            </div>
            <div class="goodSum">
              {{TotalCount}} {{TotalCount!=1?'Items':'Item'}}
            </div>
          </div>
          <el-skeleton :count="12" animated class="thousand_layout skull" :loading="loading">
            <template slot="template">
              <list-skeleton />
            </template>
            <template>
              <goods-list class="thousand_layout" :list="list" type="card" />
            </template>
          </el-skeleton>
          <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
          <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
          <!-- <f-z-f class="notfind" title="" text="Pagefault" v-else /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, resetCategory, getCategory, GetyCategories, CookiesCategory } from "@/api/public";
import GoodsList from "@/components/list/goods";
import ListPagination from '@/components/listpagination'
import NOTN from "@/components/notnull.vue";
import FZF from "@/components/404.vue";
import ListSkeleton from "@/components/skeleton.vue";

export default {
  name: "index",
  components: { GoodsList, ListPagination, NOTN, FZF, ListSkeleton },
  data() {
    return {
      userInfo: '',
      searchKey: null,
      sort: 'LastOnTimeStamp',
      sortType: 'DESC',
      activeNames: ['0', '1', '2'], // el-collapse展开——默认展开
      loading: false,
      CategoryKeys: [],
      SeachJson: [{ "Key": "Status", "Value": 1 }],
      ifData: false,
      list: {},
      Status: "1",
      all_Sort: this.$enumInfo.searchSort,
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      isPrice: '',
      isSort: 3, //筛选
      SearchCategory: [], //新类目列表
      newChild: [], //新类目二级类目
      BoxList: [], //BoxChilds
      YearList: [], //YearChilds
      newSearchJson: {
        FirstID: '', //一级标题
        SecondID: '', //二级标题
        BoxID: '',
        YearID: '',
      },
      // 选中
      isSecond: 0,
      isBox: 0,
      isYear: 0
    };
  },
  watch: {
    'userInfo': {
      handler(val) {
        //this.getDetailList()
      }
    }
  },
  created() {
    let that = this;
    this.userInfo = getInfo();
    // this.getCategoryList();
    // this.getThirdCategoryId();
    // this.getType()
    this.getNewCategory()
    // this.GoodSort(3)
  },
  mounted() {
    //this.getCategoryList();
  },
  beforeRouteUpdate(to, from, next) {
    let that = this;
    this.userInfo = getInfo();
    this.getNewCategory()
    next()
  },
  methods: {
    // 获取类目（新）
    getNewCategory() {
      let that = this
      this.Loading(true)
      let data = { language: '2' }
      this.$get(this.$interface.GetSearchConfig, data).then(res => {
        that.SearchCategory = res.data
        var id = this.$route.query.type || res.data[0]._id // 获取一级ID,
        var index = this.$route.query.index || 0 // 获取 数组下标
        that.setFirstData(id, index)

        //console.log(type,index)

        //this.Manu(this.$route.query.type, parseInt(this.$route.query.index))
      })
    },
    Loading(val) {
      this.loading = val
    },
    //SearchCommodity 根据条件获取列表数据
    getDetailList(val) {
      this.Loading(true)
      let that = this;
      let SeachJson = JSON.stringify(that.SeachJson);
      let newSearchJson = JSON.stringify(that.newSearchJson);
      let sn = window.localStorage.getItem('sn') != null ? window.localStorage.getItem('sn') : '';
      let data = { userId: 0, pageIndex: that.pi, pageSize: that.ps, searchKey: sn, searchJson: SeachJson, sort: that.sort, sortType: that.sortType, isWorld: 0, newSearchJson: newSearchJson }
      console.log(data, 'data')
      this.$get(this.$interface.GetCommodities, data).then(res => {
        if (res.result != 0) {
          var data = res.data;
          that.pi = parseInt(data.PageIndex)
          that.TotalCount = parseInt(data.TotalCount)
          that.list = data.PagedMarketItemList;
          //that.goodSum = res.data.TotalCount
          if (that.list.length == 0) {
            this.ifData = true;
          } else {
            this.ifData = false;
          }
        } else {
          this.ifData = true;
        }
        that.resultTpye = res.result

        that.Loading(false)
      })
    },
    // 获取一级类目
    setFirstData(id, index) {
      let that = this
      that.newChild = []
      that.BoxList = []
      that.YearList = []
      that.newSearchJson.FirstID = ""
      that.newSearchJson.BoxID = ""
      that.newSearchJson.YearID = ""
      that.SearchCategory.map(item => {
        if (item._id == id) {
          that.newChild = item.Childs
          that.newSearchJson.FirstID = item._id
        }
      })
      that.setSecondData(that.newChild[0], 0)
    },
    // 获取二级类目及box,year    obj:newChild  type:0 不跑列表方法 不等于0:跑列表方法
    setSecondData(obj, type) {
      let that = this
      that.newSearchJson.SecondID = obj._id // 获取对应类目的二级ID
      that.BoxList = obj.BoxChilds // 获取对应二级类目的 boxlist
      that.YearList = obj.YearChilds // 获取对应二级类目的 yearlist
      that.newSearchJson.BoxID = ""
      that.newSearchJson.YearID = ""
      that.setBoxList(obj.BoxChilds[0], 0)
      that.setYearList(obj.YearChilds[0], 0)
      if (type != 0) {
        that.getDetailList()
      }
    },
    // 获取boxlist 
    setBoxList(obj, type) {
      let that = this
      that.newSearchJson.BoxID = obj._id
      if (type != 0) {
        that.getDetailList()
      }
    },
    // 获取yearlist 
    setYearList(obj, type) {
      let that = this
      that.newSearchJson.YearID = obj._id
      that.getDetailList()
    },
    // 筛选——价格/最新上架
    GoodSort(val) {
      let that = this;
      this.isSort = val
      if (val == 0) {} {
        that.sort = '';
        that.sortType = '';
      }
      if (val == 1) {
        that.sort = that.all_Sort[0]['val'];
        that.sortType = that.all_Sort[0]['sortType'];
      }
      // 时间最新
      if (val == 3) {
        that.sort = that.all_Sort[3]['val']
        that.sortType = that.all_Sort[3]['sortType']
      }
      //价格升降
      if (val == 2) {
        that.sort = that.all_Sort[1]['val'];
        that.isPrice = !that.isPrice;
        if (that.isPrice) {
          that.sortType = that.all_Sort[1]['sortType'];
        } else {
          that.sortType = that.all_Sort[2]['sortType'];
        }
      } else {
        that.isPrice = null;
      }
      this.getDetailList('dianji');
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getDetailList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getDetailList();
    },
  },
};

</script>
<style scoped>
@import "../../../static/css/search.css";

.full_layout {
  overflow: hidden;
}

.list_right_top {
  position: relative;
}

.list_right_box {
  padding-top: 56px;
}

.border_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.goodSum {
  display: inline-block;
}

/* .list_right_box .all_item {
  border-bottom: none;
  margin: 0;
} */
/* .flex_layout_between {
  height: 100%;
  margin: 16px 0 12px;
  display: flex;
  align-items: center;
} */
.seller_tab {
  /* height: 36px; */
  display: flex;
}

.seller_tab .sort_price {
  padding: 0 12px;
  position: relative;
}

.seller_tab>div {
  cursor: pointer;
}

.sort_price .up {
  opacity: 1;
}

.el-divider--vertical {
  top: 17px;
}

.sort_price1 {
  padding-right: 14px !important;
}

/* .sort_price {
  height: 36px;
  line-height: 36px;
  padding: 9px 20px;
  border: 1px solid #e0e0e0;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  border-left: none;
  padding-right: 34px;
  position: relative;
} */
/* .sort_price:first-child {
  border-left: 1px solid #e0e0e0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-right: 20px;
}
.sort_price:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
} */
.seller_tab .up_arr {
  position: absolute;
  top: 18px;
  right: -3px;
}

.seller_tab em {
  position: absolute;
  top: 25px;
  right: -3px;
}

.sort_price1 em {
  width: 12px;
  height: 7px;
  position: absolute;
  background: #f00;
  background: url(../../../static/images/icon/icon_down_arrow.png) 0 center no-repeat;
  background-size: 60%;
  opacity: 0.6;
}

.sort_price1 .up_arr {
  background-image: url(../../../static/images/icon/icon_up_arrow.png);
}

.Manufacturer {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: flex-start;
  z-index: 3;
  background-color: #fff;
  margin: 0 0 0 42px;
}

.Manufacturer>div {
  height: 56px;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 12px 24px;
  cursor: pointer;
}

.Manufacturer>div img {
  height: 32px;
  width: 87px;
}

/* .Manufacturer > div:nth-child(2n) img {
  height: 32px;
  width: 120px;
} */

.Manufacturer>div.on {
  background-color: #f0f0f0;
}

/deep/.seach_list_left .el-collapse-item__header:hover,
.collapseSpan,
.active,
.activesort {
  color: #5f6dae !important;
}

.choose_list {
  padding: 0 16px;
  position: relative;
  cursor: pointer;
}

.choose_list.active:before {
  content: '';
  width: 2px;
  height: 2px;
  font-weight: bold;
  display: inline-block;
  position: absolute;
  left: 8px;
  top: 11px;
  background: #5f6dae;
  border-radius: 100%;
}

/* .activesort {
  background: #5f6dae;
  color: #fff;
} */

</style>



// WEBPACK FOOTER //
// src/pages/list/index.vue